import { RouteObject } from 'react-router';

import { CommonSuspense } from '../../common/components/common-suspense.tsx';
import { PublicScreenProtector } from '../../common/components/screen-protectors/public-screen-protector.tsx';

import { AuthSignInScreenLazy } from '../screens/auth/auth-sign-in.screen.lazy.tsx';
import { AuthSignUpScreenLazy } from '../screens/auth/auth-sign-up.screen.lazy.tsx';
import { AuthForgotPasswordScreenLazy } from '../screens/auth/forgot-password/auth-forgot-password-request.screen.lazy.tsx';
import { AuthForgotPasswordResetScreenLazy } from '../screens/auth/forgot-password/auth-forgot-password-reset.screen.lazy.tsx';
import { AuthForgotPasswordVerificationScreenLazy } from '../screens/auth/forgot-password/auth-forgot-password-verify.screen.lazy.tsx';

export const AuthRouter: RouteObject[] = [
  {
    path: '/auth/signup',
    element: (
      <CommonSuspense>
        <PublicScreenProtector>
          <AuthSignUpScreenLazy />
        </PublicScreenProtector>
      </CommonSuspense>
    ),
  },
  {
    path: '/auth/signin',
    element: (
      <CommonSuspense>
        <PublicScreenProtector>
          <AuthSignInScreenLazy />
        </PublicScreenProtector>
      </CommonSuspense>
    ),
  },
  {
    path: '/auth/forgot-password',
    element: (
      <CommonSuspense>
        <PublicScreenProtector>
          <AuthForgotPasswordScreenLazy />
        </PublicScreenProtector>
      </CommonSuspense>
    ),
  },
  {
    path: '/auth/forgot-password/verify',
    element: (
      <CommonSuspense>
        <PublicScreenProtector>
          <AuthForgotPasswordVerificationScreenLazy />
        </PublicScreenProtector>
      </CommonSuspense>
    ),
  },
  {
    path: '/auth/forgot-password/reset',
    element: (
      <CommonSuspense>
        <PublicScreenProtector>
          <AuthForgotPasswordResetScreenLazy />
        </PublicScreenProtector>
      </CommonSuspense>
    ),
  },
];
